import { render, staticRenderFns } from "./MiniAssignmentChip.vue?vue&type=template&id=9f45a4e4&scoped=true&"
import script from "./MiniAssignmentChip.vue?vue&type=script&lang=ts&"
export * from "./MiniAssignmentChip.vue?vue&type=script&lang=ts&"
import style0 from "./MiniAssignmentChip.vue?vue&type=style&index=0&id=9f45a4e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f45a4e4",
  null
  
)

export default component.exports